import { EntityTypes } from "./enums";

export interface EnterpriseCustomer {
    enterpriseCustomerId: string;
    enterpriseCustomerName: string;
    enterpriseCustomerShortName?: string;
    entityType: EntityTypes.enterpriseCustomer;
    contactEmails: string[];
    registrationCodes: string[];
    customerProgramName: string;
    customerLaunchDate: number;
    customerInviteCount: number;
    feedbackAndNotes: ProgramFeedback[];
    created: number;
    lastUpdated: number;
}
    
export interface ProgramFeedback {
    feedbackId: string;
    created: number;
    lastUpdated: number;
    feedbackTitle?: string;
    feedbackText: string;
    sent?: boolean;
}
export interface CreateEnterpriseCustomerProps {
    enterpriseCustomerName: string;
    enterpriseCustomerShortName?: string;
    contactEmails: string[];
    registrationCodes: string[];
    customerProgramName: string;
    customerLaunchDate: number;
    customerInviteCount: number;
}

export const CreateEnterpriseCustomerPropsSchema = {
    type: 'object',
    properties: {
        enterpriseCustomerName: { type: 'string' },
        enterpriseCustomerShortName: { type: 'string' },
        contactEmails: {
            type: 'array',  
            items: { type: 'string', format: 'email' },
        },
        registrationCodes: {
            type: 'array',
            items: { type: 'string' },
        },
        customerProgramName: { type: 'string' },
        customerLaunchDate: { type: 'number' },
        customerInviteCount: { type: 'number' },
    },
    required: [
        'enterpriseCustomerName',
        'contactEmails',
        'registrationCodes',
        'customerProgramName',
        'customerLaunchDate',
        'customerInviteCount'
    ],
    additionalProperties: false,
}

export interface UpdateEnterpriseCustomerProps {
    enterpriseCustomerName?: string;
    enterpriseCustomerShortName?: string;
    contactEmails?: string[];
    registrationCodes?: string[];
    customerProgramName?: string;
    customerLaunchDate?: number;
    customerInviteCount?: number;
}

export const UpdateEnterpriseCustomerPropsSchema = {
    type: 'object',
    properties: {
        enterpriseCustomerName: { type: 'string' },
        enterpriseCustomerShortName: { type: 'string' },
        contactEmails: {
            type: 'array',
            items: { type: 'string', format: 'email' },
        },
        registrationCodes: {
            type: 'array',
            items: { type: 'string' },
        },
        customerProgramName: { type: 'string' },
        customerLaunchDate: { type: 'number' },
        customerInviteCount: { type: 'number' },
    },
    additionalProperties: false,
}

export interface EnterpriseCustomerReport {
    reportId: string;
    enterpriseCustomerId: string;
    weekEndingDate: number;
    inviteCount: number;
    entityType: EntityTypes.enterpriseCustomerReport;
    registrationCount: number;
    intakeCount: number;
    sgpCount: number;
    sraCount: number;
    feedbackAndNotes: string;
    created: number;
}

export interface CreateEnterpriseCustomerReportProps {
    enterpriseCustomerId: string;
    weekEndingDate: number;
    inviteCount: number;
    registrationCount: number;
    intakeCount: number;
    sgpCount: number;
    sraCount: number;
    feedbackAndNotes: string;
}

export interface CreateFeedbackAPIProps {
    feedbackText: string;
    feedbackTitle?: string;
}

export const CreateFeedbackAPIPropsSchema = {
    type: 'object',
    properties: {
        feedbackText: { type: 'string', minLength: 10 },
        feedbackTitle: { type: 'string', minLength: 5 },
    },
    required: ['feedbackText'],
    additionalProperties: false,
}